export default "__VITE_ASSET__sJMkKHgw__"